export default {
  DIALOG_OPEN({ commit }, type) {
    commit("DIALOG_OPEN_MUTATION", type);
  },
  DIALOG_CLOSE({ commit }, type) {
    commit("DIALOG_CLOSE_MUTATION", type);
  }
};
